export default {
    SET_SUBSCRIBERS(state, subscribers) {
        state.subscribers = subscribers.items
        state.totalPages = subscribers.total_pages
    },
    ADD_SUBSCRIBER(state, subscriber) {
        state.subscribers.unshift(subscriber)
    },
    UPDATE_SUBSCRIBER(state, subscriber) {
        const subscriberIndex = state.subscribers.findIndex((u) => u.id === subscriber.id)
        Object.assign(state.subscribers[subscriberIndex], subscriber)
    },
    DELETE_SUBSCRIBER(state, subscriberId) {
        const ItemIndex = state.subscribers.findIndex((u) => u.id === subscriberId)
        state.subscribers.splice(ItemIndex, 1)
    },
    ADD_SUBSCRIBER_INFOS(state, subscriber) {
        state.subscriberInfos = subscriber
    }
}
